import React from "react";
import "./Support.scss";
import { useContent } from "../../../contexts/contentContext/contentContext.js";
import Button from "../..//Elements/Button/Button.js";
import { useToasts } from "react-toast-notifications";

const IsHelpfulSection = ({ externalSupportQuestion = null }) => {
  const { getTextByKey, getSupportText, setSupportQuestionHelpful } =
    useContent();
  const { addToast } = useToasts();
  //action for post vote results
  const handleVote = async (isHelpful, UserPrevVote = null) => {
    const response = await setSupportQuestionHelpful(
      externalSupportQuestion
        ? externalSupportQuestion.SystemName
        : getSupportText().question.SystemName,
      isHelpful,
      UserPrevVote
    );
    if (response === true) {
      addToast(getTextByKey("SUPPORT-voting"), {
        appearance: "success",
      });
    } else {
      return {
        message: response.message,
        status: response.status,
      };
    }
  };

  return (
    <div className="support-vote-buttons">
      <span>{getTextByKey("was-this-helpful")}</span>
      <div className="is-helpful-buttons">
        <span>
          <Button white onClick={() => handleVote(true)}>
            {getTextByKey("yes")}
          </Button>
        </span>
        <span>
          <Button white onClick={() => handleVote(false)}>
            {getTextByKey("no")}
          </Button>
        </span>
      </div>
    </div>
  );
};

export default IsHelpfulSection;
